var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 23,
    viewBox: "0 0 33 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5H33V22.5003H0V0.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5625 0.499802H14.4375V9.43727H0V13.5623H14.4375V22.4997H18.5625V13.5623H33V9.43727H18.5625V0.499802Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3807 15.3258L33 19.5589V15.3258H25.3807ZM20.0869 15.3258L33 22.4997V20.4711L23.7385 15.3258H20.0869ZM29.5604 22.4997L20.0869 17.2362V22.4997H29.5604Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0869 15.3258L33 22.4997V20.4711L23.7385 15.3258H20.0869Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0869 15.3258L33 22.4997V20.4711L23.7385 15.3258H20.0869Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.82276 15.3257L0 18.5606V15.3257H5.82276ZM12.9131 16.238V22.4997H1.64297L12.9131 16.238Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.26146 15.3258L0 20.4711V22.4997L12.9131 15.3258H9.26146Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.61933 7.6737L0 3.44067V7.6737H7.61933ZM12.9131 7.6737L0 0.499802V2.5284L9.26146 7.6737H12.9131ZM3.43961 0.499802L12.9131 5.76331V0.499802H3.43961Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9131 7.6737L0 0.499802V2.5284L9.26146 7.6737H12.9131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9131 7.6737L0 0.499802V2.5284L9.26146 7.6737H12.9131Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1772 7.67384L33 4.43893V7.67384H27.1772ZM20.0869 6.76157V0.499878H31.357L20.0869 6.76157Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7385 7.6737L33 2.5284V0.499802L20.0869 7.6737H23.7385Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_64"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 22,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGb);
export default __webpack_public_path__ + "static/media/gb.ff3e58e69d6a8b7fe8cefec3c48c4648.svg";
export { ForwardRef as ReactComponent };